import React, { useState, useEffect, useCallback } from 'react';
import SectionText from './section_text';
import SectionImage from './section_image';
import SectionInstagram from './section_instagram';
import SectionVideo from './section_video';
import SectionCourse from './section_course';
import TypeSelect from './type_select';
import {
  TEXT,
  HEADING_LARGE,
  HEADING_MEDIUM,
  HEADING_SMALL,
  IMAGE,
  INSTAGRAM,
  YOUTUBE,
  FREE,
  COURSE,
  enterContent,
} from './const';

const EnterSection = ({
  index,
  userAgent,
  addContent,
  isSelected,
  setSelectedIndex,
  setContents,
  foreignKeyId,
  model,
  hideNextButtonFunc,
  displayNextButtonFunc,
}) => {
  const [content, setContent] = useState(enterContent);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    if (
      !isSelected &&
      content.body &&
      content.body.replace(/(\r\n|\n|\r)/gm, '').length > 0
    ) {
      addContent(content);
      setContent({ ...enterContent, content_type: TEXT });
    }
  }, [isSelected]);

  const renderContent = useCallback(
    (content, index) => {
      switch (content.content_type) {
        case TEXT:
        case HEADING_LARGE:
        case HEADING_MEDIUM:
        case HEADING_SMALL:
          return (
            <SectionText
              index={index}
              content={content}
              userAgent={userAgent}
              updateContent={(content) => setContent(content)}
              isSelected={isSelected}
              setSelectedIndex={setSelectedIndex}
              deleteContent={() => {
                setContent(enterContent);
              }}
            />
          );
        case IMAGE:
          return (
            <SectionImage
              index={index}
              content={content}
              userAgent={userAgent}
              updateContent={(content) => setContent(content)}
              deleteContent={() => {
                setContent(enterContent);
              }}
              setContents={setContents}
              isSelected={isSelected}
              setSelectedIndex={setSelectedIndex}
              foreignKeyId={foreignKeyId}
              model={model}
            />
          );
        case INSTAGRAM:
          return (
            <SectionInstagram
              index={index}
              content={content}
              userAgent={userAgent}
              updateContent={(content) => setContent(content)}
              isSelected={isSelected}
              setSelectedIndex={setSelectedIndex}
              deleteContent={() => {
                setContent(enterContent);
              }}
              hideNextButtonFunc={hideNextButtonFunc}
              displayNextButtonFunc={displayNextButtonFunc}
            />
          );
        case YOUTUBE:
          return (
            <SectionVideo
              index={index}
              content={content}
              userAgent={userAgent}
              updateContent={(content) => setContent(content)}
              isSelected={isSelected}
              setSelectedIndex={setSelectedIndex}
              deleteContent={() => {
                setContent(enterContent);
              }}
              hideNextButtonFunc={hideNextButtonFunc}
              displayNextButtonFunc={displayNextButtonFunc}
            />
          );
        case FREE:
          return '無料';
        case COURSE:
          return <SectionCourse content={content} />;
        default:
          return null;
      }
    },
    [content, isSelected]
  );

  return (
    <div
      className={
        (hoveredIndex === index || isSelected) && userAgent === 'pc'
          ? 'bg-light'
          : 'bg-white'
      }
      key="contentItem_new"
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <div className="container col-md-8 pl-2 pr-2">
        <div className="d-flex">
          {userAgent === 'pc' ? (
            <div style={{ marginLeft: '-40px', paddingRight: 8 }}>
              <TypeSelect
                isCoursesDisplayed={false}
                onChangeType={(type) => {
                  setContent((prev) => ({ ...prev, content_type: type }));
                  setSelectedIndex(index);
                }}
                content={content}
                isEnterSection={true}
                userAgent={userAgent}
              />
            </div>
          ) : null}
          {renderContent(content, index)}
          <div className="d-flex flex-column align-items-center justify-content-center col-2">
            {userAgent !== 'pc' ? (
              <TypeSelect
                isCoursesDisplayed={false}
                onChangeType={(type) => {
                  setContent((prev) => ({ ...prev, content_type: type }));
                  setSelectedIndex(index);
                }}
                content={content}
                isEnterSection={true}
                deleteContent={() => {
                  setContent(enterContent);
                }}
                userAgent={userAgent}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterSection;
